import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography } from '../utils'

export const ButtonDesignSettings = {
  'button-design-full-width': {
    phone: true,
    'phone-landscape': false,
    tablet: false,
    'tablet-landscape': false,
    desktop: false,
    tv: false,
    overflowSetting: {
      phone: true,
      'phone-landscape': true,
      tablet: true,
      'tablet-landscape': true,
      desktop: true,
      tv: true,
    },
  },
  // 'button-design-width': {
  //   phone: [100],
  //   'phone-landscape': [50],
  //   tablet: [100],
  //   'tablet-landscape': [50],
  //   desktop: [20],
  //   tv: [20],
  // },

  'button-design-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },

  'button-design-padding': {
    phone: getDefaultMargin([0, 16]),
    'phone-landscape': getDefaultMargin([0, 16]),
    tablet: getDefaultMargin([0, 16]),
    'tablet-landscape': getDefaultMargin([0, 16]),
    desktop: getDefaultMargin([0, 16]),
    tv: getDefaultMargin([0, 16]),
  },
  'button-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'button-design-typography': {
    phone: getDefaultTypography('Label Medium'),
    'phone-landscape': getDefaultTypography('Label Medium'),
    tablet: getDefaultTypography('Label Medium'),
    'tablet-landscape': getDefaultTypography('Label Medium'),
    desktop: getDefaultTypography('Label Medium'),
    tv: getDefaultTypography('Label Medium'),
  },
  'button-design-color-variant': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-text-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'button-design-text-color-solid': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-text-color-start-gradient': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-text-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'button-design-text-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'button-design-scheme': {
    light: 'primary',
    dark: 'primary',
  },
  'button-design-badge-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'button-design-badge-color-solid': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-badge-color-start-gradient': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-badge-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'button-design-badge-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'button-design-icon-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'button-design-icon-color-solid': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-color-type': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'button-design-color-type-solid': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-color-type-start-gradient': {
    light: 'primary-20',
    dark: 'primary-20',
  },
  'button-design-color-type-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'button-design-color-type-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
  'button-design-group-color': {
    light: 'primary-20',
    dark: 'primary-20',
  },
}
